import React from 'react';

import Search from '../editor/Search'

const ABridTextEditor = (props) => {
    return (
        <div>
            {props.children}
            <Search />
            <hr />
            <div className="form-group">
                <label className="col-sm-3 control-label">Tytuł</label>
                <div className="col-sm-9">
                    <input type="text" name="title_normal" className="form-control" defaultValue={props.settings.title_normal} placeholder="" />
                </div>
            </div>
            <div className="form-group">
                <label className="col-sm-3 control-label">Tytuł dolny</label>
                <div className="col-sm-9">
                    <input type="text" name="label" className="form-control" defaultValue={props.settings.label} placeholder="" />
                </div>
            </div>
        </div>
    );
}


export default ABridTextEditor;